export default function FieldInfo({ field }) {
  return field.state.meta.isTouched && field.state.meta.errors.length ? (
    <small className="p-error">{field.state.meta.errors.join(",")}</small>
  ) : null;
}
